<!--
 * @Author: gaozexiong RJgaozexiong@ruijie.com.cn
 * @Date: 2022-07-14 17:23:44
 * @LastEditors: gaozexiong RJgaozexiong@ruijie.com.cn
 * @LastEditTime: 2022-10-10 10:41:54
 * @FilePath: \ces-vue-serve\src\views\Finance\file.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <div style="margin-top: 20px">
      <el-button type="primary" :loading="isprintPdfLoading" @click="printPdf">
        打印对账单
      </el-button>
      <el-upload
        action=""
        multiple
        :show-file-list="false"
        :http-request="uploadaction"
        style="display: inline-block;margin: 0 10px"
      >
        <el-button type="primary">
          上传对账单
        </el-button>
      </el-upload>

      <el-button type="primary" @click="downFiles">
        下载对账单
      </el-button>
      <el-button type="primary" :loading="isGoEsingLoading" @click="goEsing">
        电子签章
      </el-button>
      <p style="color:red;margin-top:5px">
        注：

        1.若使用纸质版对账单，请先点击“打印对账单”，打印出纸质对账单盖章后再上传对账单附件；

        2.若使用电子版对账单，请点击“电子签章”进行签章，签章完成后会自动生成对账单附件。
      </p>
    </div>
    <ul class="el-upload-list el-upload-list--text" style="margin: 10px 0">
      <el-row :gutter="60">
        <el-col v-for="(item ,index) in fileList" v-show="item.loading" :key="index" :span="9" class="el-col-auto">
          <li tabindex="0" class="el-upload-list__item is-success">
            <a class="el-upload-list__item-name">
              <i class="el-icon-document" />
              {{ item.enclosureName }}
            </a>
            <label v-if="!item.loading" class="el-upload-list__item-status-label">
              <i class="el-icon-upload-success el-icon-circle-check" />
            </label>
            <el-progress v-if="item.loading" style="margin-top: 5px" :percentage="item.percentage" :stroke-width="4" :show-text="false" />
          </li>
        </el-col>
      </el-row>
    </ul>
    <el-table v-loading="tableLoading" :data="tableData" border style="width: 100%" row-key="id" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" align="left" fixed="left" />
      <el-table-column prop="fileName" label="文件名称" align="left">
        <template v-slot="{row}">
          <el-button type="text" @click="openContract(row.fileToken)">
            {{ row.fileName }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="createName" label="上传人" align="left" />
      <el-table-column prop="createTime" label="上传时间" align="left" />
      <el-table-column prop="pname" label="操作" align="left" fixed="right">
        <template v-slot="{row}">
          <el-popover v-model="row.removeVisible" width="160">
            <p style="line-height: 30px">
              确认删除该文件吗?
            </p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="row.removeVisible = false">
                取消
              </el-button>
              <el-button type="primary" size="mini" @click="removeFile(row)">
                确定
              </el-button>
            </div>
            <el-button slot="reference" type="text" style="color: #F56C6C;">
              删除
            </el-button>
          </el-popover>
          <el-button type="text" style="margin-left: 10px" @click="downOneFile(row.fileToken)">
            下载
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top:10px">
      <el-button type="primary" @click="back">
        关闭
      </el-button>
    </div>
    <a ref="downTag" :href="fileserveDownUrl" target="_blank" />
    <do-esign ref="doEsign" @CompleteEsign="CompleteEsign" />
  </div>
</template>

<script type="es6">
// getReturnsContractAttachment,
import { selectCurrDateAvaliable, deleteAttachmentById, attachmentGetToken, createCreditReconcliation, getTokenForDownZip, creditReconElectronicSignature, printReconciliationPDF, getUrlByFileID } from '@/API';
import AxiosApi from '@/API/fileAxios';
import doEsign from '@/components/doEsign';
export default {
  data () {
    return {
      tableData: [],
      multipleSelection: [],
      fileList: [],
      tableLoading: false,
      uploadUrl: '',
      downFileUrl: '',
      token: '',
      fileserveDownUrl: '',
      isGoEsingLoading: false,
      isprintPdfLoading: false
    };
  },
  props: {
    isInit: {
      type: Boolean,
      default: true
    },
    isShow: {
      type: Boolean,
      default: true
    },
    isRed: {
      type: Boolean,
      default: false
    }
  },
  components: {
    doEsign
  },
  computed: {},
  methods: {
    searchFiles () {
      this.tableLoading = true;
      selectCurrDateAvaliable().then((res) => {
        const json = res.data;
        this.tableLoading = false;
        if (json.status === '200') {
          this.tableData = json.data;
        }
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    initToken () {
      attachmentGetToken().then((res) => {
        const json = res.data;
        if (json.status === '200') {
          this.token = json.data.token;
          this.uploadUrl = json.data.uploadUrl;
          this.downFileUrl = json.data.downloadUrl;
        }
      }).catch(() => {

      });
    },

    back () {
      this.$emit('status', false);
    },
    downFiles () {
      if (!this.multipleSelection.length) {
        this.$notify({
          title: '请至少选择一个文件',
          type: 'warning'
        });
        return;
      }

      if (this.multipleSelection.length === 1) {
        this.downOneFile(this.multipleSelection[0].fileToken);
      } else {
        const fileIds = [];
        this.multipleSelection.forEach((item) => {
          fileIds.push(item.fileToken);
        });
        let param = {
          catalogName: '下单合同集合',
          fileIds
        };
        getTokenForDownZip(param).then((res) => {
          const json = res.data;
          if (json.status === '200') {
            this.downzipFile(json.data.token, json.data.downloadZipUrl);
          }
        }).catch(() => {

        });
      }
    },
    downOneFile (id) {
      this.fileserveDownUrl = this.downFileUrl + `/${id}?Token=${this.token}`;
      this.$nextTick(() => {
        this.$refs.downTag.click();
      });
    },
    downzipFile (token, url) {
      this.fileserveDownUrl = url + `?Token=${token}`;
      this.$nextTick(() => {
        this.$refs.downTag.click();
      });
    },

    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
    submitfile (files) {
      this.tableLoading = true;
      createCreditReconcliation(files).then((res) => {
        const json = res.data;
        this.tableLoading = false;
        if (json.status === '200') {
          this.searchFiles();
        }
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    checkSpecialCharacters (str) {
    // 规则对象(flag)
      var flag = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\]<>《》/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？ ]");
      // 判断 even 是否包含特殊字符
      if (flag.test(str)) {
        return true;
      } else {
        return false;
      }
    },
    uploadaction (upload) {
      if (this.checkSpecialCharacters(upload.file.name)) {
        this.$message.error('文件名中不能包含特殊字符！');
        return;
      }
      const form = new FormData(); // 创建form对象
      form.append('files', upload.file);
      const myfile = {
        enclosureName: upload.file.name,
        loading: true,
        percentage: 0
      };
      this.fileList.push(myfile);
      AxiosApi.post(this.uploadUrl + `?Token=${this.token}`, form, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (progressEvent) => {
          myfile.percentage = (progressEvent.loaded / progressEvent.total * 100 | 0);
        }
      }).then((res) => {
        const json = res.data;
        if (json.status === '200') {
          this.submitfile([{
            fileName: json.data[0].FullName,
            fileId: json.data[0].FID
          }]);
          myfile.loading = false;
          this.$message.success(`文件“${upload.file.name}”,上传成功.`);
        } else {
          myfile.loading = false;
          this.$message.error(`文件“${upload.file.name}”,上传失败.`);
        }
      }).catch(() => {
        myfile.loading = false;
        this.$message.error(`文件“${upload.file.name}”,上传失败.`);
      });
    },
    removeFile (row) {
      this.tableLoading = true;
      deleteAttachmentById({
        id: row.id
      }).then((res) => {
        const json = res.data;
        if (json.status === '200') {
          this.searchFiles();
        } else {
          this.tableLoading = false;
        }
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    goEsing () {
      this.isGoEsingLoading = true;
      creditReconElectronicSignature().then((res) => {
        this.isGoEsingLoading = false;
        const json = res.data;
        if (json.status === '200') {
          this.$refs.doEsign.openWindow(json.data);
        }
      }).catch(() => {
        this.isGoEsingLoading = false;
      });
    },
    CompleteEsign (val) {
      if (val.isComplete) {
        this.searchFiles();
      }
    },
    printPdf () {
      this.isprintPdfLoading = true;
      printReconciliationPDF().then((res) => {
        this.isprintPdfLoading = false;
        const json = res.data;
        if (json.status === '200') {
          this.fileserveDownUrl = `/pdf/web/viewer.html?file=${encodeURIComponent(json.data)}`;
          this.$nextTick(() => {
            this.$refs.downTag.click();
          });
        }
      }).catch(() => {
        this.isprintPdfLoading = false;
      });
    },
    openContract (fileCode) {
      getUrlByFileID(fileCode).then((res) => {
        const json = res.data;
        if (json.status === '200') {
          window.open(json.data);
        }
      }).catch((res) => {

      });
    }
  },
  created () {
    if (this.isInit) {
      this.searchFiles();
    }
    this.initToken();
  }
};
</script>
